import Axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import Storage from "../storage";

export interface IePharmaServicesResponse
{
    data: any;
    error: {
        code: number;
        message: string;
    };
    messages:  {
        index: number;
        message: string;
    }[];
    pagination: {
        page: number;
        itemsPerPage: number;
        totalItems: number;
        totalPages: number;
    };
    success: boolean;
}

export default function ePharmaServices(baseUrl: string)
{
    const api = Axios.create({ baseURL: baseUrl });

    api.interceptors.request.use((config: AxiosRequestConfig) =>
    {
        const token = Storage.token.get();
        
        if (token)
            config.headers.common["Authorization"] = `Bearer ${Storage.token.get().accessToken}`;
        
        return config;
    });

    api.interceptors.response.use((response: AxiosResponse<any>) => response, async error =>
    {
        if (error.response)
        {
            switch (error.response.status)
            {
                case 401:
                case 403:
                    return window.location.href = "/error"
                default:
                    Promise.reject(error);
            }
        }

        return Promise.reject(error);
    });
    
    return api;
}